module.exports = __webpack_public_path__ + "img/w12-b2.3b01f146.jpg";